import React, { Fragment } from 'react';
import Header2 from '../../components/Header2/Header2';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const PrivacyPolicyPage = () => {
    return (
        <Fragment>
            <Header2 />
            <main className="page_content">
                <PageTitle
                    pageTitle={'Privacy Policy'}
                    pagesub={'How we protect and use your information'}
                    pageTop={'Privacy'}
                />
                <section className="section_space bg-light">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="bg-white p-4 p-md-5 rounded-4 shadow-sm">
                                    <p className="mb-4">
                                        At Krit, we respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy explains what information we collect, how we use it, and the choices you have regarding your data.
                                    </p>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">1. Information We Collect</h3>
                                        <p className="mb-0">
                                            We may collect personal information such as your name, company name, email address, phone number, project details, and any other information you voluntarily provide when contacting us, requesting a quote, or using our website.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">2. How We Use Your Information</h3>
                                        <p className="mb-0">
                                            Your information is used to respond to your inquiries, provide our services, communicate project updates, send relevant business information, improve our website experience, and comply with legal or regulatory obligations.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">3. Sharing of Information</h3>
                                        <p className="mb-0">
                                            We do not sell your personal information. We may share information with trusted service providers who assist us with website hosting, analytics, communications, or business operations, provided they are bound by confidentiality obligations.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">4. Data Security</h3>
                                        <p className="mb-0">
                                            We use reasonable technical and organizational measures to protect your personal information against unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet is completely secure.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">5. Your Rights</h3>
                                        <p className="mb-0">
                                            Depending on your location, you may have the right to access, correct, delete, or restrict the use of your personal information. You may also withdraw consent for certain communications at any time by contacting us.
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h3 className="h5 mb-3">6. Cookies and Analytics</h3>
                                        <p className="mb-0">
                                            Our website may use cookies or similar technologies to improve performance, understand visitor behavior, and personalize content. You can manage cookie preferences through your browser settings.
                                        </p>
                                    </div>

                                    <div>
                                        <h3 className="h5 mb-3">7. Changes to This Policy</h3>
                                        <p className="mb-0">
                                            We may update this Privacy Policy from time to time to reflect changes in law, technology, or our business practices. Any changes will be posted on this page with an updated effective date.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default PrivacyPolicyPage;
